import { Dimensions } from 'react-native';

const { height: SCREEN_HEIGHT, width: SCREEN_WIDTH } = Dimensions.get('window');

// Accepts number input representing percentage (e.g., 5 => 5%)
export const heightPercentageToDP = (heightPercent: number) => {
  const percent =
    typeof heightPercent === 'string'
      ? parseFloat(heightPercent)
      : heightPercent;
  return (SCREEN_HEIGHT * percent) / 100;
};

export const widthPercentageToDP = (widthPercent: number) => {
  const percent =
    typeof widthPercent === 'string' ? parseFloat(widthPercent) : widthPercent;
  return (SCREEN_WIDTH * percent) / 100;
};

export default {
  heightPercentageToDP,
  widthPercentageToDP,
};
